import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, MarginBox, Text } from 'UI';
import { textFormatter } from 'utils/format';

export interface DetailsSectionLineProps {
  sectionName: string;
  totalVatExcl?: number;
  vat?: number;
  currency?: string;
  dataCy?: string;
}

const DetailsSectionLine = ({ sectionName, totalVatExcl, vat, currency, dataCy }: DetailsSectionLineProps) => {
  const { t } = useTranslation();

  return (
    <Flex data-cy={dataCy}>
      <Flex size={4}>
        <Text type="base" bold>
          {sectionName}
        </Text>
      </Flex>
      <Flex />
      <Flex size={6}>
        <Flex justify={'flex-end'}>
          <Text type="base">
            {t('common.price.vat_exclude_price', '{{vat_exclude_price}} VAT. Excl', {
              vat_exclude_price: textFormatter.formatCurrency(totalVatExcl ?? 0, currency),
            })}
          </Text>
        </Flex>
      </Flex>
      <MarginBox mr={30} />
      <Flex size={4}>
        <Flex justify={'flex-start'}>
          <Text type="base">{t('common.price.vat', 'VAT:')}</Text>
        </Flex>
        <Flex justify={'flex-end'}>
          <Text type="base">{textFormatter.formatCurrency(vat ?? 0, currency)}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DetailsSectionLine;
